var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor cache-delete" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("tables.automationblock.cacheKey"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t(
                "tables.automationblock.cacheDeleteKeyPlaceholder"
              ),
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.key,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "key", $$v)
              },
              expression: "clone.key",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", [
        _c(
          "div",
          { staticClass: "pattern-toggle" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.clone.usePattern,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "usePattern", $$v)
                  },
                  expression: "clone.usePattern",
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$t("tables.automationblock.usePatternMatching")
                    ) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.clone.usePattern
          ? _c("div", { staticClass: "pattern-help" }, [
              _c("div", { staticClass: "help-title" }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("pattern")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("tables.automationblock.patternMatchingHowItWorks")
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pattern-examples" }, [
                _c("div", { staticClass: "example" }, [
                  _c("code", [_vm._v(_vm._s(_vm.$t("auto.cacheDeleteChat3")))]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("tables.automationblock.patternExChatStar"))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "example" }, [
                  _c("code", [_vm._v(_vm._s(_vm.$t("auto.cacheDeleteChat2")))]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("tables.automationblock.patternExStarChat"))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "example" }, [
                  _c("code", [_vm._v(_vm._s(_vm.$t("auto.cacheDeleteChat")))]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("tables.automationblock.patternExStarChatStar")
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "example" }, [
                  _c("code", [_vm._v("user_session")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("tables.automationblock.patternExExactMatch")
                      )
                    ),
                  ]),
                ]),
              ]),
            ])
          : _c("div", { staticClass: "help-text" }, [
              _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("tables.automationblock.exactMatchOnlyHelp"))
                ),
              ]),
            ]),
      ]),
      _vm._v(" "),
      _vm.clone.usePattern
        ? _c("section", [
            _c("div", { staticClass: "warning-box" }, [
              _c("i", { staticClass: "material-icons" }, [_vm._v("warning")]),
              _vm._v(" "),
              _c("div", [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("tables.automationblock.warningTitle"))),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "tables.automationblock.patternMatchingIrreversibleWarning"
                      )
                    )
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "output-info" }, [
          _c("div", { staticClass: "info-title" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("output")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("tables.automationblock.outputInfo"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "output-attributes" }, [
            _c("div", { staticClass: "attribute-item" }, [
              _c("code", [
                _vm._v(
                  _vm._s(_vm.$t("auto.cacheDeleteBlockBlockidDeletedcount"))
                ),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("tables.automationblock.deletedCountLabel"))
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "attribute-item" }, [
              _c("code", [
                _vm._v(_vm._s(_vm.$t("auto.cacheDeleteBlockBlockidSuccess"))),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("tables.automationblock.successBooleanLabel"))
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }